export const PaginatorInfoFragment = `
	paginatorInfo {
		currentPage
		lastPage
		perPage
		total
	}
`
